<template>
  <div class="gift-wrapper">
    <page-nav :isJump="true" class="left-nav"></page-nav>
    <gift-component />
    <footer-bar class="footerbar"></footer-bar>
  </div>
</template>

<script>
import pageNav from "@/components/nav"
import FooterBar from "@/components/footer";
import giftComponent from "@/components/Gift"
import { mapState } from 'vuex'
export default {
  name: 'Gift',
  components: {
    pageNav,
    giftComponent,
    FooterBar
  },
  data() {
    return {

    }
  },
  methods: {

  },
  mounted() {

  },
  computed: {
  },
}
</script>

<style lang="scss" scoped>
.gift-wrapper {
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
  background: url('../assets/images/gift/bg_pc.png') no-repeat;
  background-attachment: fixed;
  background-size: cover;
  background-position: center;

  .footerbar {
    margin-top: 100px;
  }

  .left-nav {
    position: absolute;
    z-index: 4;
    top: 0.5263157895rem;
    left: 0.3157894737rem;
  }
}
</style>